import clsx from 'clsx';
import React from 'react';

import TrinityAudioPlayer from '@components/TrinityAudio';
import useInlineLinkTracking from '@hooks/useInlineLinkTracking';
import { TrackingLocation } from '@tracking';
import { AuthoredContentReactToHtmlParser } from '@utils/reactHtmlParserTransform';

import styles from './styles.module.scss';

interface BriefingBodyProps {
  body: string;
  isSEOBot: boolean;
  isAudioActive: boolean;
}

const Body = ({ body, isSEOBot, isAudioActive }: BriefingBodyProps) => {
  useInlineLinkTracking({
    trackingLocation: TrackingLocation.ContentBody,
    targetSelector: '.briefing-body',
  });

  return (
    <div
      className={clsx(
        styles.briefingBody,
        'briefing-body clipperable-content break-words font-noto-serif text-body-articles',
        {
          'seo-paywall-content': isSEOBot,
        }
      )}
      data-nosnippet
    >
      {isAudioActive && <TrinityAudioPlayer />}
      {AuthoredContentReactToHtmlParser(body)}
    </div>
  );
};

export default Body;
